const theme = /*SNIP*/{
    colors: {
        transparent: 'transparent',
        current: 'currentColor',
        brand1: {
            DEFAULT: '#f97316',
            dark: '#ea580c',
            darkest: '#c2410c',
            light: '#fb923c',
            lightest: '#ffedd5'
        },
        brand2: '#0f172a',
        black: '#0f172a',
        white: '#ffffff',
        gray: {
            darkest: '#334155',
            dark: '#475569',
            DEFAULT: '#64748b',
            light: '#cbd5e1',
            lightest: '#f8fafc',
        },
        slate: {
            50: '#f8fafc',
            100: '#f1f5f9',
            200: '#e2e8f0',
            300: '#cbd5e1',
            400: '#94a3b8',
            500: '#64748b',
            600: '#475569',
            700: '#334155',
            800: '#1e293b',
            900: '#0f172a',
        },
        blue: {
            darkest: '#1e3a8a',
            dark: '#1d4ed8',
            DEFAULT: '#3b82f6',
            light: '#60a5fa',
            lightest: '#dbeafe',
        },
        pink: {
            dark: '#831843',
            DEFAULT: '#db2777',
            light: '#f472b6'
        },
        danger: {
            DEFAULT: '#ef4444',
            light: '#f87171',
            lightest: '#fee2e2',
        },
        green: {
            DEFAULT: '#10b981',
            light: '#34d399',
            lightest: '#d1fae5',
        }
    },
    spacing: {
        px: '1px',
        0: '0px',
        0.5: '0.125em',
        1: '0.25em',
        1.5: '0.375em',
        2: '0.5em',
        2.5: '0.625em',
        3: '0.75em',
        3.5: '0.875em',
        4: '1em',
        5: '1.25em',
        6: '1.5em',
        7: '1.75em',
        8: '2em',
        9: '2.25em',
        10: '2.5em',
        11: '2.75em',
        12: '3em',
        14: '3.5em',
        16: '4em',
        20: '5em',
        24: '6em',
        28: '7em',
        32: '8em',
        36: '9em',
        40: '10em',
        44: '11em',
        48: '12em',
        52: '13em',
        56: '14em',
        60: '15em',
        64: '16em',
        72: '18em',
        80: '20em',
        96: '24em',
    },
    fontFamily: {
        sans: ['Plus Jakarta Sans', 'Inter', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'sans-serif'],
        serif: ['Merriweather', 'serif'],
    },
    fontSize: {
        xs: ['0.75em', { lineHeight: '1.3' }],
        sm: ['0.875em', { lineHeight: '1.4' }],
        base: ['1em', { lineHeight: '1.5' }],
        lg: ['1.125em', { lineHeight: '1.5' }],
        xl: ['1.25em', { lineHeight: '1.4' }],
        '2xl': ['1.5em', { lineHeight: '1.3' }],
        '3xl': ['1.875em', { lineHeight: '1.2' }],
        '4xl': ['2.25em', { lineHeight: '1.2' }],
        '5xl': ['3em', { lineHeight: '1.1' }],
        '6xl': ['3.75em', { lineHeight: '1.1' }],
        '7xl': ['4.5em', { lineHeight: '1' }],
        '8xl': ['6em', { lineHeight: '1' }],
        '9xl': ['8em', { lineHeight: '1' }],
    },
    form: {
        wrapper: {
            display: 'flex',
            flexDirection: 'flex-col',
            flexGrow: 'flex-grow',
            spaceBetween: 'space-y-2',
        },
        label: {
            fontSize: 'text-sm',
            color: 'text-slate-700',
            fontWeight: 'font-semibold',
        },
        input: {
            padding: 'py-0',
        },
        highlighted: {
            borderRadius: 'rounded-xl',
            borderColor: 'border-brand1-lightest',
            border: 'border',
            margin: '-mx-2 my-2',
            padding: 'p-3',
        },
        embedded: {
            borderRadius: 'rounded-xl',
            backgroundColor: 'bg-slate-50',
            margin: '-mx-2 my-2',
            padding: 'py-2 px-4',
        },
        saveButton: {
            kind: 'primary',
        },
        generalErrorText: {
            backgroundColor: 'bg-danger-lightest',
            borderRadius: 'rounded-lg',
            padding: 'p-3',
            color: 'text-danger',
        },
        generalErrorTextWrapper: {
            padding: 'p-1',
        },
        propertyErrorTextWrapper: {
            padding: 'p-1',
        },
        propertyErrorText: {
            color: 'text-danger',
            fontSize: 'text-xs',
        },
        surround: {
            position: 'absolute',
            positionClass: 'top-0',
            width: 'w-2',
            height: 'h-2',
            backgroundColor: 'bg-brand1',
            marginLeft: '-ml-0.5',
            marginTop: '-mt-0.5',
        },
        width: {
            '9/10': '90%',
        }
    }
}/*SNIP*/
export default theme

